import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

export default function PageLayout({ children }) {
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
      <Header />
      <div className="container-fluid flex-grow-1 p-0">
        <div className="row g-0 h-100">
          <Sidebar />
          <main className="col-md-9 col-lg-10 px-3 px-md-4 py-3">
            {children}
            <Footer />
          </main>
        </div>
      </div>
    </div>
  );
}
